<div class="backspinner" *ngIf="mode === 'indeterminate'">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<section class="payment-wrapper">
  <div class="container">
    <div class="pc-details d-flex justify-content-between flex-wrap">
      <div class="payment-details">
        <div class="payment-form">
          <h1>Provide your card details</h1>
          <span class="secure-info">100% safe and secure</span>
          <form [formGroup]="paymentcard">
            <div class="input-grp d-flex justify-content-between flex-wrap">
              <div class="inputfield-wrap">
                <input type="text" id="holdername" formControlName="holdername" placeholder="Card Holder Name">
                <div *ngIf="isSubmiited && f.holdername.errors" class="invalid-feedback">
                  <span *ngIf="f.holdername.errors.required" class="validation-message">*Please enter name on credit
                    card</span>
                </div>
              </div>
              <div class="inputfield-wrap card-number">
                <input type="text" id="card-no" formControlName="cardno" (keypress)="chekNumber($event)"
                  class="card-number" placeholder="Card Number">
                <i class="icon-date"></i>
                <div *ngIf="isSubmiited && f.cardno.errors" class="invalid-feedback">
                  <span
                    *ngIf="f.cardno.errors.required || f.cardno.errors.pattern || f.cardno.errors.minlength || f.cardno.errors.maxlength"
                    class="validation-message">*Please enter credit card number</span>
                </div>
              </div>
            </div>
            <!-- justify-content-between flex-wrap -->
            <div class="expiry-wrap row ">
              <div class="inputfield-wrap card-number col-md-4">
                <input type="text" id="expiryYear" formControlName="expiryYear" placeholder="EXP (MM/YY)"
                  (keyup)="updateKey($event)" (keypress)="chekNumber($event)">
                <div *ngIf="isSubmiited && f.expiryYear.errors" class="invalid-feedback">
                  <span *ngIf="f.expiryYear.errors.required" class="validation-message">*Expiry details are
                    required</span>
                </div>
              </div>
              <div class="inputfield-wrap card-number col-md-4">
                <input type="password" id="cvvs" formControlName="cvv" placeholder="CVV"
                  (keypress)="chekNumber($event)">
                <div *ngIf="isSubmiited && f.cvv.errors" class="invalid-feedback">
                  <span
                    *ngIf="f.cvv.errors.required || f.cvv.errors.minlength || f.cvv.errors.maxlength || f.cvv.errors.pattern"
                    class="validation-message">*Please enter the security code from your credit card</span>
                </div>
              </div>
              <div class="inputfield-wrap card-number col-md-4">
                <input type="text" id="zip" formControlName="zipcode" placeholder="Zip Code"
                  (keypress)="chekNumber($event)">
                <div *ngIf="isSubmiited && f.zipcode.errors" class="invalid-feedback">
                  <span *ngIf="f.zipcode.errors.pattern" class="validation-message">*Please enter the zip code from your
                    credit card</span>
                </div>
              </div>
            </div>
            <div class="various-platform">
              <ul class="online-platform d-flex justify-content-center justify-content-sm-between flex-wrap">
                <li>
                  <a>
                    <i class="icon-visaplatform"></i>
                  </a>
                </li>
                <li>
                  <a>
                    <i class="icon-discover"></i>
                  </a>
                </li>
                <li>
                  <a>
                    <i class="icon-mastercard"></i>
                  </a>
                </li>
                <li>
                  <a>
                    <i class="icon-ae"></i>
                  </a>
                </li>
              </ul>
            </div>
            <p style="padding:'10px';">By starting my Membership, I confirm that I have read and agree to the
              <a class="cursorHand fontWt600" routerLink="/terms-conditions" target="_blank">Terms of Service</a> and
              <a class="cursorHand fontWt600" routerLink="/privacy_policy" target="_blank">Privacy Policy</a> and I
              authorize mylifewell to charge my payment method for the membership as described above.
            </p>
            <span [ngStyle]="{'color':'red'}">{{errorMessage}}</span>
            <a [ngClass]="{'low-amount':(0>=totalPrice )}" (click)="submitPaymentDetails()" class="orderplace-btn">Start
              Your Membership</a>
          </form>
        </div>
      </div>
      <div class="payment-banner plan-pricedetails">
        <div *ngIf="subscriberdata && subscriberdata.length>0">
          <div class="note-msg" *ngIf="showdays">
            <h6 class="plan-title d-flex align-items-center justify-content-between"><strong>Start your 30 day free
                trial</strong></h6>
            <p>*Please note:Your card will not be charged until the end of your free trial period {{expireTrialDate}}.
              You can cancel at anytime by logging into the "My Account" section.</p>
          </div>
          <h2 class="detail-title d-flex align-items-center justify-content-between"><strong>Plan Details</strong> <span
              [routerLink]="['/plan']"><img src="assets/images/edit-icn.png" alt="edit"></span></h2>
          <ul class="list-view">
            <ng-container *ngFor="let obj of subscriberdata;let i=index">
              <li *ngIf="obj && obj['price']!=null && obj['price']!=undefined" class="price-set">
                <span class="name">{{obj['planUsename']}}
                  <span>({{obj['subscriptionName']}})</span><small>({{obj['subscriptionType'] === '' ? 'One-time' :
                    obj['subscriptionType']}} <small *ngIf="obj['isTrial'] && !obj['isTrialUsed'] ">&nbsp;After 30 Day
                      Free Trial</small>)</small></span>

                <span class="price">{{((obj['Originalprice']!=null &&
                  obj['Originalprice']!=undefined)?getRound(obj['Originalprice']):'') | currency:'USD':'symbol':'1.2-2'
                  }}</span>

                <span *ngIf="obj['planUsename']!=='plan'" class="delete-wrap">
                  <span class="delete" (click)="delData(obj['planUsename'],i)"><img src="assets/images/delete.svg"
                      alt="delete">
                  </span>
                </span>
              </li>
            </ng-container>
          </ul>
          <div class="total-price d-flex align-items-center justify-content-between"
            *ngIf="((DiscountPrice && DiscountPrice>0))  "><strong class="order-totaltext">Discounts</strong><strong
              class="value-part">{{getRound(DiscountPrice) | currency:'USD':'symbol':'1.2-2'}}</strong></div>
          <hr *ngIf="((DiscountPrice && DiscountPrice>0))">
          <div class="total-price d-flex align-items-center justify-content-between"
            *ngIf="totalPrice!=null && totalPrice!=undefined"><strong class="order-totaltext">Order
              Total</strong><strong class="value-part">{{getRound(totalPrice-DiscountPrice) |
              currency:'USD':'symbol':'1.2-2'}}</strong></div>
          <div class="final-checkout promo-checkout" *ngIf="(totalPrice-DiscountPrice)>0">
            <h2 class="text-capitalize">Apply Promo Code</h2>
            <form>
              <div class="promo-wrap">
                <button *ngIf="appliedCode" class="promo-button" (click)="removeCode('')">x</button>
                <input type="text" placeholder="enter promo code here" (keydown)="keyCheck($event)"
                  [ngModelOptions]="{standalone: true}" [(ngModel)]="appliedCode">
                <i class="icon-gift"></i>
              </div>
              <button class="promo-submit" (click)="applyCode()">Apply</button>
              <span *ngIf="status" [ngStyle]="{'color':'#0a5fae','margin-left':'27px'}">{{status}}</span>
            </form>
          </div>
          <!-- until the end of your free trial period 11/20/2020 -->
        </div>
      </div>
    </div>
  </div>
</section>
<div class="enquiry-poup">
  <app-modal-pop-up [responseMessage]="responseMessage" *ngIf="showAlert" (triggerCloseEvent)="triggerCloseEvent()">
  </app-modal-pop-up>
</div>